<template>
  <div class="mb-12 flex justify-between">
    <div class="flex items-center space-x-8">
      <button
        class="rounded-lg body-1 flex h-full cursor-pointer items-center space-x-16 bg-transparent px-16 py-8 hover:bg-action-default-min-hover motion-safe:transition motion-safe:duration-300 motion-safe:ease-in"
        @click="$emit('back')"
      >
        <IconArrowLeft aria-labelledby="backLabel" size="medium" />
        <span id="backLabel">{{ i18n(translations.back) }}</span>
      </button>
    </div>

    <RevButtonIcon
      v-if="withExit"
      :alternative-text="i18n(translations.exit)"
      :icon="IconCross"
      variant="secondary"
      @click="$emit('exit')"
    />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButtonIcon } from '@ds/components/ButtonIcon'
import { IconArrowLeft } from '@ds/icons/IconArrowLeft'
import { IconCross } from '@ds/icons/IconCross'

import translations from './Navigation.translations'

const i18n = useI18n()

defineProps<{
  withExit?: boolean
}>()

defineEmits(['back', 'exit'])
</script>
